<template>
  <div>
    <div
      v-click-outside="closeDropdown"
      class="dropdown"
    >
      <div
        class="selected-option"
        @click="toggleDropdown"
      >
        Exportar em
        <md-icon class="arrow">
          {{ showDropdown ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </md-icon>
      </div>
      <ul
        v-show="showDropdown"
        class="dropdown-list"
      >
        <li
          v-for="option in options"
          :key="option"
          @click="selectOption(option)"
        >
          {{ option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { clickOutside } from '@/utils/directives'

export default {
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside
  },
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedOption: '',
      showDropdown: false
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },
    selectOption(option) {
      this.selectedOption = option
      this.closeDropdown()
      this.$emit('optionSelected', option)
    },
    closeDropdown() {
      this.showDropdown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  padding: 0 8px 0 20px;
  border: 1px solid #e8eaed;
  border-radius: 5px;
  background: #7f1a54;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  height: 40px;
  min-width: 170px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  .selected-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    background-color: #7f1a54;
    color: #fff;
    width: 100%;

    .md-icon {
      margin: 0;
    }
  }

  .dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #fcfcfc;
    border-radius: 0 0 6px 6px;
    color: #7f1a54;

    li {
      padding: 10px;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        background-color: #ccc;
      }
    }
  }
}
</style>
